<template>
  <div id='tamilParticipationInfo' class="section">
    <a href="/consent-form-tamil">
      <i class="fa fa-arrow-left"></i>
    </a>
    <div class="box">
      <h1 class="title has-text-centered"> ஆய்வில் பங்கேற்பவர்களுக்கான தகவல் </h1>
      <h4 class="has-text-centered"><b>ஆய்வில் பங்கேற்பவர்களுக்கான தகவல் </b></h4><br>
      <h4 class="has-text-centered"> <b> ஸ்கார்ப் நடத்தும் ஆய்வு </b> – பள்ளி மற்றும் கல்லூரி சார்ந்த செயல்முறைகள் மூலம் இளைஞர்களுக்கிடையே மனச்சிதைவு நோயினை ஆரம்ப கட்டதிலேயே கண்டறிந்து அவர்களுக்கான பரிந்துறைகளை மேற்கொள்ளுதல் பற்றிய ஆய்வு </h4><br>
      <p>
          மனச்சிதைவு ஆராய்ச்சி மையம் நடத்தும் இந்த ஆய்வில் பங்கேற்க நீங்கள் அழைக்கப்பட்டுள்ளீர்கள். இந்த ஆய்வை வழி நடத்துவர் டாக்டர் ஆர்.தாரா. பள்ளி மற்றும் கல்லூரி மாணவர்களிடையே முதல் தடவை தோன்றக்கூடிய மனநோய்க்கான அறிகுறிகளை ஆரம்பகட்டத்திலேயே கண்டறிந்து அதனை பராமரிப்பது பற்றிய ஒரு நிகழ்வின் அங்கமே இந்த ஆய்வாகும்.
      </p>
      <p>
          இந்த ஆராய்ச்சியில் பங்கு பெறும் முன் இந்த ஆய்வு எதற்காக நடக்கிறது என்பதை அறிந்து கொள்வது மிக அவசியம். நேரம் எடுத்துக் கொண்டு இந்த தகவல் படிவத்தை கவனமாகப் படிக்கவும். உங்களுக்கு இதில் ஏதாவது புரியவில்லை என்றாலோ, மேலும் விவரங்கள் தேவைப்பட்டாலோ தயங்காமல் கேட்டுத் தெரிந்துக் கொள்ளுங்கள். நன்கு யோசித்து, இந்த ஆய்வில் பங்குப் பெறுவதா, இல்லையா என்பதை முடிவெடுக்கவும்
      </p>
      <p>
          இந்த தகவல் படிவத்தை படித்தமைக்கு நன்றி 
      </p><br>
      <p><b>இந்த ஆய்வின் நோக்கம் என்ன? </b></p>
      <p>
          இந்த ஆய்வு சமுதாயத்தில் இளைஞர்கள் மனநலம் குறித்து விழிப்புணர்வு மற்றும் மனநோய்க்கான அறிகுறிகளை ஆரம்பகட்டத்திலேயே கண்டறிவதற்கான ஒரு திட்டமைப்பை உருவாக்குவதே இந்த ஆய்வின் நோக்கமாகும். இந்த ஆய்வில் பள்ளி மற்றும் கல்லூரி சார்ந்த மன நலம் சார்ந்த நிகழ்வுகள் உருவாக்கப்படும். இவை ஆசிரியர்கள் மற்றும் மாணவர்களிடையே செயல்படுத்தப்படும்.
      </p><br>
      <p><b>நீங்கள் எதற்காக இதில் பங்கேற்க அழைக்கப்பட்டிருக்கிறீர்கள்? </b></p>
      <p>
          நீங்கள் இந்த ஆய்வில் பங்கு பெறுவதற்கான காரணம் என்னவென்றால், இந்த ஆய்வு நடத்தப்படும் பள்ளியில் அல்லது கல்லுரியில் மாணவர்களாக உள்ளீர்கள். 
      </p><br>
      <p><b>இதில் நீங்கள் பங்கேற்க்க வேண்டுமா? </b></p>
      <p>
          இதில் பங்கு பெறலாமா அல்லது வேண்டாமா என்பதை பற்றி முடிவு செய்வது உங்களிடமே உள்ளது. நீங்கள் பங்குபெற முடிவு செய்தால் ஒப்புதல் படிவத்தில் கையொப்பம் இட்டு கலந்து கொண்ட பிறகு விருப்பம் இல்லையென்றால் எந்த நேரத்திலும் இதிலிருந்து விலகிக் கொள்ளலாம்.
      </p><br>
      <p><b>இதில் நான் பங்கேற்ப்பதால் எனக்கு என்ன பயன்? </b></p>
      <p>
          இந்த ஆய்வில் நீங்கள் பங்கேற்பதால் உங்களின் மனநலம் பற்றிய புரிதல் மேம்படும். அதுமட்டுமன்றி இந்த ஆய்வின் மூலம் அறியப்படும் தகவல்கள் இளைஞர்கள் மனநலம் மற்றும் மனநோய்கள் பற்றி நாங்கள் தெளிவு பெற உதவும். அதனை அறிந்து இளைஞர்கள் மனநலத்தை முன்னேற்றம் அடைய வழிவகுக்கும்.
      </p><br>
      <p><b>இந்த ஆய்வின் செயல்முறை என்ன? </b></p>
      <p>
          மனநலம் சார்ந்த ஒரு செயலி மூலம் உங்கள் மனநலம் பற்றி கேட்கப்படும் கேள்விகளுக்கு நீங்கள் பதிலளிக்க வேண்டும். இவை சுமாராக 15 நிமிடம் எடுக்கும்.
      </p><br>
      <p><b>இதில் பங்கேற்பதால் ஏற்படும் நன்மை, தீமை என்ன? </b></p>
      <p>
          இதில் நீங்கள் பங்கேற்பதால் உங்கள் நேரம் செலவாகும். அதைத்தவிர வேறெந்த தீமைகள் மற்றும் ஆபத்து இல்லை.
      </p><br>
      <p><b>இதில் நான் பங்கேற்பது ரகசியமாக இருக்குமா? </b></p>
      <p>
          நீங்கள் இந்த ஆராய்ச்சியில் பங்கு கொண்டால் நீங்கள் கொடுக்கும் தகவல்கள் அல்லது உங்களை பற்றிய விஷயங்கள் ரகசியமாக வைத்து பாதுகாக்கப்படும். கேள்வித்தாள் மற்றும் நேர்காணல் அனைத்திலும் உங்கள் பெயர் இடம் பெறாது உங்களை நாங்கள் மட்டுமே கண்டுகொள்ள முடியும் அனைத்து தகவல்களும் மிக துல்லியமாக கணிணியில் மிகவும் பாதுகாப்பாக வைக்கப்படும்.	
      </p><br>
      <p><b>இந்த ஆராய்ச்சியின் முடிவுகள் என்ன நடக்கும்? </b></p>
      <p>
          இந்த ஆய்வின் முடிவுகள் அறிவியல், மருத்துவ நாளிதழ்கள் மற்றும் மாநாடுகளில் சமர்பிக்கப்படும். இந்த ஆய்விற்குத் தேவையான தகவல் சேகரிப்பு முடிந்து பகுப்பாய்வு செய்யப்பட்ட பிறகு வெளியிடப்பட்ட பிரதிகள் உங்கள் கோரிக்கைகளுக்கு இணங்க உங்களுக்கு கிடைக்கும். எக்காரணத்திலும் இதில் உங்கள் பெயர் இடம் பெறாது என்று உறுதியளிக்கின்றோம்.
      </p><br>
      <p><b>இந்த ஆராய்ச்சியை ஒருங்கிணைத்து மற்றும் நிதியுதவி அளிப்பது யார்? </b></p>
      <p>
          இந்த ஆய்வு ஸ்கார்பில் உள்ள ஆராய்ச்சியாளர்களால் வார்விக் பல்கலைகழகத்துடன் இனைந்து நடத்தபடுகிறது. இந்த ஆய்விற்கான நிதிஉதவி நேஷனல் இன்ஸிடிடுயுட் ஆப் ஹெல்த் ரிசர்ச், இங்கிலாந்திலிருந்து பெறப்படுகிறது.
      </p><br>
      <p><b>இந்த ஆராய்ச்சியினை பரிசீலனை செய்தது யார்? </b></p>
      <p>
          நன்னெறிக்குழு இந்த ஆய்வினை மருத்துவ மற்றும் நன்னெறி நெறிமுறைகள் மற்றும் அறிவியல் மதிப்பீடு இருக்கின்றதா என பரிசீலனை செய்கிறது,
      </p><br>
      <p><b>மேலும் விவரங்களுக்கு தொடர்பு கொள்ள </b></p>
      <p>இந்த ஆய்வை பற்றி மேலும் தகவல் பெற விரும்பினால் தயவு செய்து தொடர்பு கொள்ளவும். </p><br>
      <p>மருத்துவர். ஆர்.தாரா </p>
      <p>இயக்குநர் </p>
      <p>ஸ்காhப் (மனச்சிதைவு நோய் ஆராய்ச்சி மையம்) </p>
      <p>ஆர்ஃ7ஏ வடக்கு பிரதான சாலை, </p>
      <p>அண்ணாநகர், மேற்கு விரிவாக்கம் </p>
      <p>சென்னை – 600 101</p>
      <p>தொலைபேசி – 044-26153917</p><br>
      <p>ஆய்வு தொடர்பான புகார்கள் இருப்பின் தொடர்பு கொள்ள வேண்டிய முகவரி: </p><br>
      <p>மருத்துவர் இலட்சுமி விஐயக்குமார் </p>
      <p>செயற்குழு தலைவர் </p>
      <p>ஸ்கார்ப் - இந்தியா </p>
      <p>தொலைபேசி – 044-24981939</p><br>
      <p><b>உங்கள் வருகைக்கு நன்றி. உங்களிடம் உள்ள தகவல் தாள் மற்றும் ஒப்புதல் படிவத்தில் கையெழுத்திட்டு அதன் நகலை நீங்கள் வைத்துக் கொள்ளவும். </b></p><br>
	</div>
  </div>
</template>

<script>

export default {
  name: 'tamilParticipationInfo',
  methods: {
    next() {
      this.$router.push('demographics');
    },
  },
  created() {
    window.scroll(0, 0);
    console.log('general info created');
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TamilParticipationInfo.vue